export default __webpack_public_path__ + "static/media/calculation.3fd41e54.svg";